import entities from '@shared/entities';

export const useGetSoilCapitalCountryList = () => {
    const { staticCountryState } = entities.staticCountry.useState();

    const countries = staticCountryState.list.filter((country) => !!country.carbon_program);

    return { countries };
};
